export const RuleType = {
	User: 1,
	Bet: 2
};

export const ActionType = {
	PreBet: 1,
	PostBet: 2,
	Visibility: 3,
	Result: 4
};
